import logger from "@/utils/logging"

export class ApiError extends Error {
    public readonly errorCode: string

    constructor(message: string, code: string) {
        // We need to hack it this way as otherwise Typescript loses type : https://github.com/Microsoft/TypeScript/issues/13965
        const trueProto = new.target.prototype
        super(message)
        this.errorCode = code
        // @ts-ignore
        this.__proto__ = trueProto
    }
}
